<template>
  <v-card v-if="trainerObj" class="obstacle-trainer-card" :class="$vuetify.theme.dark ? 'transparent03--dark' : 'transparent03'">
    <div class="obstacle-trainer-portrait">
      <img v-if="trainerObj.img" :src="require(`@/assets/pic/trainer/${trainerObj.img}`)" alt="" />
    </div>
    <div class="obstacle-trainer-overlay"></div>

    <div v-if="hasRolled" class="obstacle-trainer-info-box">
      <div class="obstacle-trainer-skill-name">{{ lastSkill.name }}</div>
      <div class="obstacle-trainer-roll">
        <template v-if="!isIneffective">
          <v-icon size="18" color="white" class="mr-1">mdi-dice-multiple</v-icon>
          <span class="obstacle-trainer-roll-part">{{ rollBase }}</span>
          <span class="obstacle-trainer-roll-op">+</span>
          <span class="obstacle-trainer-roll-part">{{ dungValue }}</span>
          <span class="obstacle-trainer-roll-op">=</span>
          <span class="obstacle-trainer-roll-total">{{ dmg }}</span>
        </template>
        <span v-else class="obstacle-trainer-noeffect">{{ $t('journey.obstacleTrainerCard.noEffect') }}</span>
      </div>
    </div>

    <div class="obstacle-trainer-dung-box">
      <v-icon size="44" color="white">mdi-pickaxe</v-icon>
      <span class="obstacle-trainer-dung-value">{{ dungValue > 0 ? '+' : '' }}{{ dungValue }}</span>
    </div>
  </v-card>
</template>

<script>
import {mapActions} from 'vuex';

// Karta hráče v obstacle módu - nahrazuje dřívější CombatantSlot kind="trainer".
// Obstacle nemá pokémona, takže místo "choose pokemon"/PokemonDetail karty je
// tu obrázek trenéra + jeho Dungeoneering skill + výsledek posledního hodu.
export default {
  name: 'ObstacleTrainerCard',
  props: {
    trainerId: {type: Number, default: null},
    obstacleFight: {type: Object, default: null},
  },
  data() {
    return {
      trainerObj: null,
    }
  },
  computed: {
    dungValue() {
      return this.trainerObj.trainerSkills.dung;
    },
    lastSkill() {
      return this.obstacleFight ? this.obstacleFight.lastSkill : null;
    },
    hasRolled() {
      return !!this.lastSkill;
    },
    dmg() {
      return this.obstacleFight ? this.obstacleFight.dmg : 0;
    },
    isIneffective() {
      return this.hasRolled && this.dmg === 0;
    },
    // dmg uz v sobe ma zapocitany dung (viz ObstacleFight::getDmg() na
    // backendu) - odecteni je spolehlivejsi nez spolehat na poradi kostek
    // v lastDices poli.
    rollBase() {
      return this.dmg - this.dungValue;
    },
  },
  created() {
    this.getTrainer(this.trainerId).then((data) => {
      this.trainerObj = data;
    });
  },
  methods: {
    ...mapActions({
      getTrainer: 'trainer/loadItem',
    }),
  },
}
</script>

<style scoped>
.obstacle-trainer-card {
  position: relative;
  /* Mobil: vyplni svou 50% grid radku (chooseMode grid-template-rows:1fr 1fr). */
  height: 100%;
  overflow: hidden;
}
@media (min-width: 960px) {
  .obstacle-trainer-card {
    /* Desktop: vlastni radek gridu bez souseda, ktery by ho natahl -
       vynuceno na pevnych 400px jako ObstacleDetail.vue. */
    height: 400px;
  }
}
.obstacle-trainer-portrait {
  position: absolute;
  inset: 0;
  overflow: hidden;
}
.obstacle-trainer-portrait img {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 200%;
  width: auto;
  max-width: none;
}
/* Jen dekorativni podklad pro citelnost rohovych ctverecku - nema vlastni
   obsah v toku, potrebuje vyslovnou vysku, jinak by se zhroutil na 0px. */
.obstacle-trainer-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 45%;
  background: linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,0,0,0.0) 100%);
  pointer-events: none;
}
.obstacle-trainer-info-box {
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: inline-flex;
  flex-direction: column;
  gap: 6px;
  background: rgba(0,0,0,0.45);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 12px;
  padding: 10px 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  color: #fff;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.9);
}
.obstacle-trainer-skill-name {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.85;
}
.obstacle-trainer-roll {
  display: inline-flex;
  align-items: center;
  font-weight: 700;
  font-size: 17px;
}
.obstacle-trainer-roll-part {
  opacity: 0.9;
}
.obstacle-trainer-roll-op {
  margin: 0 6px;
  opacity: 0.7;
  font-weight: 600;
}
.obstacle-trainer-roll-total {
  font-size: 22px;
  font-weight: 800;
  color: #ffd54f;
  margin-left: 2px;
}
.obstacle-trainer-noeffect {
  font-size: 15px;
  font-weight: 700;
  color: #ff8a80;
}
.obstacle-trainer-dung-box {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-width: 64px;
  min-height: 64px;
  background: rgba(0,0,0,0.45);
  border: 1px solid rgba(255,255,255,0.25);
  border-radius: 5px;
  padding: 6px 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.4);
  color: #fff;
  text-shadow: 1px 1px 3px rgba(0,0,0,0.9);
}
.obstacle-trainer-dung-value {
  font-size: 22px;
  font-weight: 800;
  color: #fff;
  margin-left: -4px;
}
</style>
